import VerifyPhoneConsentPage from "./verify.phone.consent.page";

export default VerifyPhoneConsentPage;
